export const PAYMENT_METHODS = ["Cash", "BankTransfer", "CardExternal", "Other"];
export const PAYMENT_STATUSES = [
    "Unpaid",
    "Pending",
    "Paid",
    "OnHold",
    "Failed",
    "Refunded",
    "Voided",
];
export const PAYMENT_DECISIONS = ["PaidNow", "PayLater"];
export const REVOKE_PAYMENT_ACTIONS = ["KeepPayment", "Refund", "Void"];
/** Stable machine-readable codes returned by the payment endpoints; clients localize the copy. */
export const PAYMENT_ERROR_CODES = {
    paymentNotFound: "PaymentNotFound",
    paymentMethodRequired: "PaymentMethodRequired",
    paymentMethodInvalid: "PaymentMethodInvalid",
    paymentDateInvalid: "PaymentDateInvalid",
    paymentDecisionInvalid: "PaymentDecisionInvalid",
    paymentReasonRequired: "PaymentReasonRequired",
    paymentReasonTooLong: "PaymentReasonTooLong",
    refundDateRequired: "RefundDateRequired",
    invalidPaymentTransition: "InvalidPaymentTransition",
    voidPaidRequiresOwner: "VoidPaidRequiresOwner",
    paidPaymentAlreadyExists: "PaidPaymentAlreadyExists",
    paidOverrideRequiresOwner: "PaidOverrideRequiresOwner",
    idempotencyKeyInvalid: "IdempotencyKeyInvalid",
    idempotencyKeyConflict: "IdempotencyKeyConflict",
    revokeDecisionRequired: "RevokeDecisionRequired",
    revokeDecisionInvalid: "RevokeDecisionInvalid",
    planChangeSourcePaymentRequired: "PlanChangeSourcePaymentRequired",
    planChangeAmbiguousSourcePayment: "PlanChangeAmbiguousSourcePayment",
    planChangeSamePlan: "PlanChangeSamePlan",
    planChangeDifferenceDecisionRequired: "PlanChangeDifferenceDecisionRequired",
};
export const IDEMPOTENCY_KEY_HEADER = "Idempotency-Key";
